import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { NotificationModel } from './noti'
import { Notification } from './notification';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class NotificationService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allNotification(data): Promise<NotificationModel[]> {
        return this.httpmanagerService.HttpPost('snotification/allnotification', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    deleteNotification(id): Promise<Notification> {
        return this.httpmanagerService.HttpDelete('snotification', id).then(data => {
            return data;
        })
    }
    inNotification(data): Promise<NotificationModel> {
        return this.httpmanagerService.HttpPost('snotification/create', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    pushNotification(data): Promise<Notification> {
        return this.httpmanagerService.HttpPost('snotification/pushnotification', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/notification/notification.service.ts